module.exports = __webpack_public_path__ + "img/demeter-logo-transparent.7e824ccf.png";